import { spawn } from 'redux-saga/effects';

import { watchExitEditor } from './exitEditor';

export default function* saga() {
  yield spawn(watchExitEditor);
}
